import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Input, Alert } from '../../components/ui';
import api from '../../services/api';

const BLOCKED_DOMAINS = ['gmail.com','yahoo.com','hotmail.com','outlook.com','live.com','aol.com','icloud.com','protonmail.com'];
const PURPOSES = ['B2B Outreach','B2C Marketing','Newsletter','Product Announcements','Lead Generation','Event Invitations','Follow-up Campaigns','Partnership Outreach','Other'];

const INDIAN_STATES = ['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Delhi','Jammu & Kashmir','Ladakh','Puducherry','Chandigarh','Other'];

export default function ClientRegister() {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    username:'', name:'', email:'', password:'', confirmPassword:'',
    company:'', phone:'', purposeOfSending:'',
    country:'India', state:'Tamil Nadu', city:'', address:'', pincode:'', gstNumber:'',
  });
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const isIndia = form.country === 'India';

  const validateStep = (s) => {
    const e = {};
    if (s === 1) {
      if (!form.username) e.username = 'Required';
      if (!form.name) e.name = 'Required';
      if (!form.email) e.email = 'Required';
      else {
        const domain = form.email.split('@')[1]?.toLowerCase();
        if (BLOCKED_DOMAINS.includes(domain)) e.email = 'Use your business/domain email. Personal emails not allowed.';
      }
      if (!form.password || form.password.length < 8) e.password = 'Min 8 characters';
      if (form.password !== form.confirmPassword) e.confirmPassword = 'Passwords do not match';
    }
    if (s === 2) {
      if (!form.company) e.company = 'Required';
      if (!form.phone) e.phone = 'Required';
      if (!form.purposeOfSending) e.purposeOfSending = 'Required';
    }
    if (s === 3) {
      if (!form.country) e.country = 'Required';
      if (isIndia && !form.state) e.state = 'Required';
      if (!form.city) e.city = 'Required';
      if (!form.address) e.address = 'Required';
    }
    return e;
  };

  const nextStep = () => {
    const e = validateStep(step);
    setErrors(e);
    if (Object.keys(e).length === 0) setStep(s => s + 1);
  };

  const handleRegister = async () => {
    setLoading(true); setApiError('');
    try {
      const res = await api.post('/auth/register', form);
      localStorage.setItem('token', res.data.token);
      navigate('/client/payment');
    } catch (err) { setApiError(err.response?.data?.message || 'Registration failed'); }
    finally { setLoading(false); }
  };

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const STEPS = ['Account','Business','Address','Review'];

  return (
    <div style={{ minHeight: '100vh', background: '#0A0A0A', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ position: 'fixed', top: '10%', left: '50%', transform: 'translateX(-50%)', width: 600, height: 600, background: 'radial-gradient(circle, rgba(46,204,113,0.04) 0%, transparent 70%)', pointerEvents: 'none' }} />
      <div style={{ width: '100%', maxWidth: 540 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <span style={{ fontSize: 28, fontWeight: 900, color: '#2ECC71', letterSpacing: -1 }}>MARK</span>
          <span style={{ fontSize: 13, fontWeight: 500, color: '#666', marginLeft: 8 }}>Ms Discoveries</span>
          <p style={{ color: '#555', fontSize: 13, marginTop: 6 }}>Create your EmailMark account</p>
        </div>

        {/* Step indicator */}
        <div style={{ display: 'flex', gap: 0, marginBottom: 24 }}>
          {STEPS.map((s, i) => (
            <div key={s} style={{ flex: 1, textAlign: 'center' }}>
              <div style={{ height: 4, borderRadius: 2, background: i + 1 <= step ? '#2ECC71' : '#222', marginBottom: 5, transition: 'background 0.3s' }} />
              <div style={{ fontSize: 11, color: i + 1 === step ? '#2ECC71' : i + 1 < step ? '#555' : '#333', fontWeight: i + 1 === step ? 700 : 400 }}>
                {i + 1 < step ? '✓ ' : ''}{s}
              </div>
            </div>
          ))}
        </div>

        <div style={{ background: '#111', border: '1px solid rgba(46,204,113,0.15)', borderRadius: 20, padding: 32 }}>
          {apiError && <Alert type="danger" style={{ marginBottom: 16 }}>{apiError}</Alert>}

          {/* ── STEP 1: ACCOUNT ── */}
          {step === 1 && (
            <>
              <h3 style={{ fontSize: 17, fontWeight: 800, marginBottom: 20 }}>Account Information</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <Input label="Username *" placeholder="johnsmith" value={form.username} onChange={e => f('username', e.target.value)} error={errors.username} />
                <Input label="Full Name *" placeholder="John Smith" value={form.name} onChange={e => f('name', e.target.value)} error={errors.name} />
              </div>
              <Input label="Business Email *" type="email" placeholder="john@yourcompany.com" value={form.email} onChange={e => f('email', e.target.value)} error={errors.email} hint="Personal emails (Gmail, Yahoo etc.) are not accepted" />
              <Input label="Password *" type="password" placeholder="Min. 8 characters" value={form.password} onChange={e => f('password', e.target.value)} error={errors.password} />
              <Input label="Confirm Password *" type="password" placeholder="Repeat password" value={form.confirmPassword} onChange={e => f('confirmPassword', e.target.value)} error={errors.confirmPassword} />
            </>
          )}

          {/* ── STEP 2: BUSINESS ── */}
          {step === 2 && (
            <>
              <h3 style={{ fontSize: 17, fontWeight: 800, marginBottom: 20 }}>Business Details</h3>
              <Input label="Company Name *" placeholder="Acme Pvt. Ltd." value={form.company} onChange={e => f('company', e.target.value)} error={errors.company} />
              <Input label="Phone Number *" placeholder="+91 9000000000" value={form.phone} onChange={e => f('phone', e.target.value)} error={errors.phone} />
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#ccc', marginBottom: 6 }}>Purpose of Sending Emails *</label>
                <select value={form.purposeOfSending} onChange={e => f('purposeOfSending', e.target.value)} style={{ width: '100%', padding: '10px 14px', background: '#1a1a1a', border: `1px solid ${errors.purposeOfSending ? '#E74C3C' : 'rgba(46,204,113,0.15)'}`, borderRadius: 10, color: form.purposeOfSending ? '#fff' : '#555', fontSize: 14, outline: 'none' }}>
                  <option value="">Select purpose...</option>
                  {PURPOSES.map(p => <option key={p} value={p}>{p}</option>)}
                </select>
                {errors.purposeOfSending && <div style={{ fontSize: 12, color: '#E74C3C', marginTop: 4 }}>⚠ {errors.purposeOfSending}</div>}
              </div>
            </>
          )}

          {/* ── STEP 3: ADDRESS ── */}
          {step === 3 && (
            <>
              <h3 style={{ fontSize: 17, fontWeight: 800, marginBottom: 6 }}>Address & Tax Details</h3>
              <p style={{ fontSize: 12, color: '#555', marginBottom: 20 }}>Used for invoice generation and GST calculation.</p>

              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#ccc', marginBottom: 6 }}>Country *</label>
                <select value={form.country} onChange={e => f('country', e.target.value)} style={{ width: '100%', padding: '10px 14px', background: '#1a1a1a', border: `1px solid ${errors.country ? '#E74C3C' : 'rgba(46,204,113,0.15)'}`, borderRadius: 10, color: '#fff', fontSize: 14, outline: 'none' }}>
                  <option value="India">🇮🇳 India</option>
                  <option value="Germany">🇩🇪 Germany</option>
                  <option value="United States">🇺🇸 United States</option>
                  <option value="United Kingdom">🇬🇧 United Kingdom</option>
                  <option value="UAE">🇦🇪 UAE</option>
                  <option value="Singapore">🇸🇬 Singapore</option>
                  <option value="Australia">🇦🇺 Australia</option>
                  <option value="Canada">🇨🇦 Canada</option>
                  <option value="Other">🌍 Other</option>
                </select>
              </div>

              {isIndia && (
                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#ccc', marginBottom: 6 }}>State *</label>
                  <select value={form.state} onChange={e => f('state', e.target.value)} style={{ width: '100%', padding: '10px 14px', background: '#1a1a1a', border: `1px solid ${errors.state ? '#E74C3C' : 'rgba(46,204,113,0.15)'}`, borderRadius: 10, color: '#fff', fontSize: 14, outline: 'none' }}>
                    {INDIAN_STATES.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                  {errors.state && <div style={{ fontSize: 12, color: '#E74C3C', marginTop: 4 }}>⚠ {errors.state}</div>}
                </div>
              )}

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <Input label="City *" placeholder="Chennai" value={form.city} onChange={e => f('city', e.target.value)} error={errors.city} />
                <Input label="Pincode / ZIP" placeholder="600001" value={form.pincode} onChange={e => f('pincode', e.target.value)} />
              </div>
              <Input label="Street Address *" placeholder="No. 123, Main Street" value={form.address} onChange={e => f('address', e.target.value)} error={errors.address} />

              {isIndia && (
                <>
                  <Input label="GST Number (optional)" placeholder="e.g. 33XXXXX1234X1ZX" value={form.gstNumber} onChange={e => f('gstNumber', e.target.value.toUpperCase())} hint="Enter your GSTIN if you have one — it will appear on invoices" />

                  {/* GST preview */}
                  <div style={{ background: 'rgba(46,204,113,0.05)', border: '1px solid rgba(46,204,113,0.15)', borderRadius: 10, padding: '12px 16px', fontSize: 12, color: '#888' }}>
                    <div style={{ fontWeight: 700, color: '#2ECC71', marginBottom: 6 }}>🇮🇳 GST Applicable</div>
                    {form.state === 'Tamil Nadu'
                      ? <div>Since you're in <strong style={{ color: '#ccc' }}>Tamil Nadu</strong> (same state as MS Discoveries): <strong style={{ color: '#F39C12' }}>SGST 9% + CGST 9% = 18%</strong></div>
                      : <div>Since you're in <strong style={{ color: '#ccc' }}>{form.state || 'another state'}</strong>: <strong style={{ color: '#F39C12' }}>IGST 18%</strong></div>
                    }
                  </div>
                </>
              )}

              {!isIndia && (
                <div style={{ background: 'rgba(52,152,219,0.05)', border: '1px solid rgba(52,152,219,0.15)', borderRadius: 10, padding: '12px 16px', fontSize: 12, color: '#888', marginTop: 8 }}>
                  <div style={{ fontWeight: 700, color: '#3498DB', marginBottom: 4 }}>🌍 International Client</div>
                  <div>No GST applicable for international clients. Prices in EUR.</div>
                </div>
              )}
            </>
          )}

          {/* ── STEP 4: REVIEW ── */}
          {step === 4 && (
            <>
              <h3 style={{ fontSize: 17, fontWeight: 800, marginBottom: 20 }}>Review & Confirm</h3>
              <div style={{ background: '#1a1a1a', borderRadius: 12, padding: 16, marginBottom: 20 }}>
                {[
                  ['Username', form.username], ['Name', form.name], ['Email', form.email],
                  ['Company', form.company], ['Phone', form.phone],
                  ['Country', form.country], ['State', form.state || '—'],
                  ['City', form.city], ['Address', form.address],
                  ['GST Number', form.gstNumber || 'Not provided'],
                  ['Purpose', form.purposeOfSending],
                ].map(([l, v]) => (
                  <div key={l} style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 0', borderBottom: '1px solid rgba(255,255,255,0.04)', fontSize: 13 }}>
                    <span style={{ color: '#555' }}>{l}</span>
                    <span style={{ color: '#ccc', fontWeight: 500, maxWidth: 260, textAlign: 'right', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v}</span>
                  </div>
                ))}
              </div>
              <Alert type="info" style={{ marginBottom: 16 }}>After registration you will select a plan and complete payment to activate your account.</Alert>
            </>
          )}

          {/* Navigation */}
          <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
            {step > 1 && <Button variant="secondary" onClick={() => setStep(s => s - 1)} style={{ flex: 1 }}>← Back</Button>}
            {step < 4 && <Button onClick={nextStep} style={{ flex: step > 1 ? 2 : 1 }}>Next →</Button>}
            {step === 4 && <Button loading={loading} onClick={handleRegister} style={{ flex: 2 }}>✅ Create Account</Button>}
          </div>

          <div style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: '#555' }}>
            Already have an account? <Link to="/client" style={{ color: '#2ECC71', fontWeight: 600 }}>Login here</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
